import { ref } from 'vue'

const title = ref('')
const mobileTitle = ref('')

export function usePageHeader(pageTitle?: string, pageMobileTitle?: string) {
    if (pageTitle !== undefined) {
        title.value = pageTitle
        document.title = pageTitle + ' - Gestion'
    }

    if (pageMobileTitle !== undefined) {
        mobileTitle.value = pageMobileTitle
    } else if (pageTitle !== undefined) {
        mobileTitle.value = pageTitle
    }

    return { title, mobileTitle }
}
